import {
    makeRootClasses,
    defaultClasses as baseClasses,
    defaultGlobals as baseGlobals,
} from '@basecom-gmbh/pond/formkit.theme';

export const defaultClasses: Record<string, Record<string, boolean>> = {
    ...baseClasses,
    // Shared Button Styles
    'family:button__input': {
        'py-2': true,
        'px-8': true,
        'w-full': true,
        'sm:w-fit': true,
        'h-11': true,
    },
    // Primary Button
    submit__input: {
        'transition-color ease-in-out duration-200': true,
        'bg-neutral-800': true,
        'rounded-full': true,
        'hover:bg-neutral-700': true,
        'text-neutral-100 font-bold': true,
        'disabled:bg-disabled-dark': true,
        'disabled:text-disabled-light': true,
        'disabled:cursor-not-allowed': true,
    },
    // Secondary Button
    button__input: {
        'bg-white': true,
        border: true,
        'border-neutral-800': true,
        'hover:border-neutral-700': true,
        'text-neutral-800': true,
        'disabled:bg-disabled-dark': true,
        'disabled:text-disabled-light': true,
        'disabled:cursor-not-allowed': true,
        'disabled:border-disabled-dark': true,
        'disabled:text-disabled-dark': true,
        'rounded-full': true,
    },
    select__inner: {
        'border border-neutral-500 rounded-full': true,
        'bg-transparent': true,
        'px-4 py-2': true,
        'gap-2': true,
        flex: true,
        'focus-within:bg-neutral-300': true,
        'group-data-[invalid]:border-accent-red': true,
        'group-data-[disabled]:border-gray': true,
        'group-data-[disabled]:text-gray': true,
        'group-data-[disabled]:bg-gray-light': true,
    },
    select__label: {
        block: true,
        'pb-1': true,
        'text-sm': true,
    },
    select__input: {
        'w-full': true,
        'outline-none': true,
        'group-data-[disabled]:bg-gray-light': true,
        'group-data-[empty]:opacity-45': true,
        'bg-transparent': true,
    },
    // Text Input
    'family:text__inner': {
        border: true,
        'border-neutral-500 rounded-full': true,
        'bg-white': true,
        'gap-2': true,
        'px-4 py-2': true,
        flex: true,
        'group-data-[invalid]:border-accent-red': true,
        'group-data-[invalid]:text-accent-red': true,
        // TODO: only apply if the input actually has validation rules
        // 'group-data-[complete]:border-status-success-dark': true,
        // 'group-data-[complete]:text-status-success-dark': true,
        'group-data-[disabled]:border-neutral-300': true,
        'group-data-[disabled]:text-neutral-400': true,
        'group-data-[disabled]:bg-neutral-300': true,
        'group-data-[disabled]:cursor-not-allowed': true,
        'focus-within:bg-neutral-300': true,
    },
    'family:text__input': {
        'group-data-[disabled]:bg-neutral-300': true,
        'group-data-[disabled]:cursor-not-allowed': true,
        'placeholder:!text-neutral-500': true,
        'focus:bg-neutral-300': true,
        peer: true,
    },
    'family:text__label': {
        'text-sm': true,
        block: true,
        'pb-1': true,
    },
    'family:text__suffixIcon': {
        'group-data-[disabled]:text-brand-secondary': true,
    },
    // textarea input
    textarea__input: {
        border: true,
        'border-gray': true,
        'rounded-xl': true,
        'bg-white': true,
        'w-full': true,
        'resize-none': true,
        'py-2': true,
        'px-4': true,
    },
    textarea__label: {
        block: true,
        'pb-1': true,
        'text-sm': true,
    },
    checkbox__decorator: {
        'rounded size-4 w-4': true,
        'overflow-hidden': true,
        'after:block': true,
        'after:w-full': true,
        'after:h-full': true,
        'after:bg-neutral-100': true,
        'after:relative': true,
        'after:z-10': true,
        'peer-checked:border-neutral-800': true,
        'peer-checked:bg-neutral-100': true,
        'peer-checked:text-neutral-100': true,
        'peer-checked:after:label:bg-accent-orange': true,
        'peer-checked:after:hidden': true,
        'peer-checked:after:text-neutral-800': true,
    },
    checkbox__decoratorIcon: {
        'max-w-[66.66%]': true,
        'text-neutral-800': true,
    },

    radio__decorator: {
        'rounded-full': true,
        'peer-checked:bg-brand-primary': false,
        'peer-checked:border-neutral-800': true,
        'peer-checked:after:block': true,
        'peer-checked:after:m-[4px]': true,
        'peer-checked:after:w-[6px]': true,
        'peer-checked:after:h-[6px]': true,
        'peer-checked:after:rounded-[50%]': true,
        'peer-checked:after:bg-neutral-800': true,
    },
    radio__decoratorIcon: {
        hidden: true,
    },
    'family:box__wrapper': {
        '!mb-2': true,
        'inline-flex': true,
        'items-center': true,
        'group-data-[multiple]:mb-0': true,
        'hover:cursor-pointer': true,
    },
    'family:box__decorator': {
        'mr-2': true,
        'bg-white': true,
        relative: true,
        block: true,
        'w-4': true,
        'aspect-square': true,
        border: true,
        'border-black': true,
        'text-transparent': true,
        'select-none': true,
        'group-data-[disabled]:!cursor-not-allowed': true,
        'peer-checked:border-brand-primary': true,
        'peer-checked:bg-brand-primary': true,
        'peer-checked:text-white': true,
        'peer-focus-visible:ring-2': true,
        'peer-focus-visible:ring-offset-1': true,
        'peer-disabled:bg-neutral-300': true,
        'peer-disabled:border-neutral-400': true,
        'peer-disabled:peer-checked:border-neutral-400': true,
        'peer-disabled:text-neutral-300': true,
        'peer-disabled:peer-checked:text-neutral-600': true,
        'peer-disabled:cursor-not-allowed': true,
    },
};

export const defaultGlobals: Record<string, Record<string, boolean>> = {
    ...baseGlobals,
    message: {
        'text-sm': true,
        'text-accent-red': true,
        'mt-2': true,
    },
};

const rootClasses = makeRootClasses(defaultClasses, defaultGlobals);
export { rootClasses };
